import React from 'react';
import Modal from './Modal';
import Button from './Button';

/**
 * Read-only "view mode" for a record.
 *
 * sections: [{ title?, items: [{ label, value, full? }] }]
 *   - value: any node; null/undefined/'' renders as an em dash
 *   - full: span both columns (use for long text such as remarks)
 * footer: optional extra buttons rendered before Close
 */
export default function DetailModal({ open, onClose, title, sections = [], footer, size = 'lg' }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size={size}
      footer={
        <>
          {footer}
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <div className="space-y-4">
        {sections.map((s, i) => (
          <div key={s.title || i}>
            {s.title && (
              <p className="mb-2 border-b border-gray-100 pb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">
                {s.title}
              </p>
            )}
            <dl className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
              {s.items.map((it) => (
                <div key={it.label} className={it.full ? 'sm:col-span-2' : ''}>
                  <dt className="text-xs text-gray-500">{it.label}</dt>
                  <dd className="mt-0.5 whitespace-pre-wrap break-words text-sm text-gray-800">
                    {it.value === null || it.value === undefined || it.value === '' ? '—' : it.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        ))}
      </div>
    </Modal>
  );
}
